import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { FaqItem } from 'src/app/core/models/lead-campaign';

@Component({
  selector: 'app-faq-home',
  templateUrl: './faq-home.component.html',
  styleUrls: ['./faq-home.component.scss']
})
export class FaqHomeComponent implements OnDestroy {

  public category: 'general' | 'campaigns' | 'leads' = 'general';
  public loading: boolean = false;
  public timer;
  public faq: FaqItem[] = [{
    question: `O Lopes Leads vai me trazer mais leads do que qualquer outra campanha
      que eu faça?`,
    answer: `Sim, o objetivo do Lopes Leads é te entregar mais leads do que você 
      conseguiria sozinho, fazendo seu investimento render mais. Isso é possível 
      pois nossas campanhas são operadas com base numa inteligência desenvolvida 
      por profissionais com anos de expertise em mídia digital do Lopes Labs.`,
    category: 'leads',
    wasUseful: null
  }, {
    question: `Dos leads que recebo, como saberei quais são do Lopes Leads?`,
    answer: `Se um lead vem de uma campanha de mídia, é possível ver o nome da 
      mesma nos comentários da respectiva FAC. Caso o nome da campanha contenha 
      a sigla "LL" (referência às iniciais de Lopes Leads), significa que o lead 
      veio de uma campanha do Lopes Leads.`,
    category: 'leads',
    wasUseful: null
  }, {
    question: `Quantos leads receberei com esse investimento?`,
    answer: `Como estamos falando de campanhas de performance, não há um custo 
      por lead pré-determinado que nos ajude a garantir um volume fechado de 
      leads. As variáveis que impactam esse resultado são muitas. O volume de 
      leads varia de acordo com fatores como: o investimento, o perfil do 
      produto, a segmentação escolhida, e a performance da campanha. Lembrando 
      que o objetivo do Lopes Leads é te entregar mais leads do que você 
      conseguiria sozinho.`,
    category: 'leads',
    wasUseful: null
  }, {
    question: `Como conseguirei ver os resultados e leads dessa campanha?`,
    answer: `Assim que a campanha for ativada, você receberá por email um link 
      de acesso a um relatório. Lá você poderá acompanhar o status da campanha 
      e o desempenho do volume de leads.`,
    category: 'leads',
    wasUseful: null
  }, {
    question: `Se outro colega solicitar uma campanha para o mesmo produto que 
      o meu, estaremos competindo nas mídias?`,
    answer: `Pelo contrário, vocês estarão unindo forças e cada corretor 
      receberá o volume de leads correspondente ao investimento colocado. 
      O Lopes Leads foi construído de forma a impedir a competição entre 
      campanhas para um mesmo produto.`,
    category: 'campaigns',
    wasUseful: null
  }, {
    question: `O que as campanhas do Lopes Leads têm de melhor do que outras?`,
    answer: `As campanhas que veiculamos são geridas com base numa inteligência 
      desenvolvida dentro do Lopes Labs por profissionais especialistas e com anos 
      de experiência em marketing digital e contam com investimentos feitos pela 
      Lopes na estrutura do Lopes Labs.`,
    category: 'campaigns',
    wasUseful: null
  }, {
    question: `Enviei o formulário de inscrição. Em quanto tempo minha campanha 
    estará ativa?`,
    answer: `O Lopes Leads funciona em janelas mensais. Se você se inscrever até 
    a data limite de inscrições, sua campanha será ativada na primeira semana do 
    próximo mês. Lembrando que o pagamento do boleto é necessário para que a 
    campanha seja ativada.`,
    category: 'campaigns',
    wasUseful: null
  }, {
    question: `Como saberei se preenchi minha solicitação da maneira correta?`,
    answer: `Caso você tenha preenchido o formulário com alguma das informações 
      fora dos nossos parâmetros (ex.: com valor de investimento inferior a 
      R$ 600), enviaremos um email comunicando que a sua solicitação foi cancelada 
      e, para torná-la válida novamente, você deverá enviar uma outra solicitação.`,
    category: 'campaigns',
    wasUseful: null
  }, {
    question: `As regras de retorno são válidas para as campanhas de Lopes Leads?`,
    answer: `Sim, todas as campanhas respeitam a regra de retorno, sempre 
      privilegiando os corretores que mantem suas FACs atualizadas. Assim o 
      cliente, embora tenha sido impactado pela campanha de Lopes Leads, será 
      distribuído para o corretor que estava atendendo ele com fac atualizada.`,
    category: 'campaigns',
    wasUseful: null
  }, {
    question: `Como saberei se a campanha está ativa ou se já acabou?`,
    answer: `Assim que as campanhas forem ativadas, enviaremos um comunicado 
      avisando. Quanto ao fim, será sempre na última semana do mês.`,
    category: 'campaigns',
    wasUseful: null
  }, {
    question: `Tenho que ser especialista em marketing digital para participar?`,
    answer: `Não, pelo contrário. Você conta com profissionais especialistas em 
      mídia digital para gerir as campanhas. Assim, as mesmas são potencializadas, 
      você recebe mais leads, e foca no que sabe fazer de melhor: vender.`,
    category: null,
    wasUseful: null
  }];
  public filteredFaq: FaqItem[] = this.faq;

  constructor(private router: Router) { }

  ngOnDestroy(): void {
    clearTimeout(this.timer);
  }

  goBack(): void {
    this.router.navigate(['/lopes-leads']);
  }

  filterFaq(category: 'general' | 'campaigns' | 'leads'): void {
    const filter = {
      'campaigns': () => this.faq.filter(item => item.category === category),
      'leads': () => this.faq.filter(item => item.category === category),
      'general': () => this.faq
    }

    this.filteredFaq = filter[category]();
    this.category = category;
  }

  inputChange(event): void {
    this.loading = true;
    clearTimeout(this.timer);

    this.timer = setTimeout(() => {
      const searchValue = event.target.value;
      if (!['?', '/', '['].includes(searchValue)) {
        const regex = new RegExp(`${searchValue}`, 'gi');
        this.filteredFaq = this.faq.filter(item =>
          item.question.search(regex) != -1 ||
          item.answer.search(regex) != -1
        );
        this.category = 'general';
        this.loading = false;
      }
    }, 800);
  }

  sendMail(): void {
    window.open("mailto:lopesleads@lopes.com.br?subject=Dúvidas sobre o Lopes Leads", '_blank');
  }

  sendMessage(): void {
    window.open('https://api.whatsapp.com/send?phone=5511940598940&text=Olá!%20Estou%20com%20dúvidas%20sobre%20o%20Lopes%20Leads!', '_blank')
  }
}